export default __webpack_public_path__ + "static/media/ProductTotal.ed796a28.png";